import { createFileRoute } from '@tanstack/react-router';
import { ContractEditRoute } from '@/pages/contracts/form-route';

/**
 * Il suffisso `_` rende la modifica sorella del dettaglio: annidata sotto
 * `$id` (che non ha Outlet) non verrebbe mai montata.
 */
export const Route = createFileRoute(
  '/referrer/_layout/contracts/_layout/$id_/edit'
)({
  component: ContractEditRouteComponent,
});

function ContractEditRouteComponent() {
  const { id } = Route.useParams();

  return <ContractEditRoute contractId={id} />;
}
